module.exports = "/_next/static/images/sale-303c7f64f09306b35b5a425336d074d4.svg";